import { Service } from "./service";

export const Services = ({ data }) => {
  return (
    <>
      <div id="services" className="text-center">
        <div className="container">
          <div className="section-title">
            <h2>HİZMETLERİMİZ</h2>
          </div>

          <div className="row">
            {data
              ? data.map((d, i) => (
                  <div key={`${d.title}-${i}`} className="col-md-4">
                    <a
                      className="page-scroll"
                      href={`#service-${i + 1}`}
                      style={{ display: "block" }}
                    >
                      <i className={d.icon}></i>

                      <div className="service-desc">
                        <h3>{d.title}</h3>
                      </div>
                    </a>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
      </div>

      {/* ALTTA içerik */}
      {data?.map((s, i) => (
        <Service key={i} data={s} no={i + 1} />
      ))}
    </>
  );
};
